const constants = (DV7access, customDV7Access) =>
({
	alertcheckboxes: [
		{ id: 'hdderror', title: 'SD Error' },
		{ id: 'uncleanshutdown', title: 'Improper shutdown' },
		{ id: 'videoloss', title: 'Camera failure' },
	],
	eventcheckboxes: [
		{ id: 'fatalgsensor', title: 'High G-Force Event' },
		{ id: '%_clip,%_alert,%_event', title: 'Custom Video' },
		{ id: 'highspeed', title: 'Max Speed Event' },
		{ id: 'inputsensor5,inputsensor9', title: 'Driver Event' },
		{ id: 'inputsensor', title: 'Input Sensor Event' },
		{ id: 'harshbraking', title: 'Harsh Braking Event' },
		{ id: 'harshaccel', title: 'Harsh Acceleration Event' },
		...(DV7access ?
			[
				...(!customDV7Access ? [{ id: 'gsensor_wakeup', title: 'G-Sensor Wake-Up' }] : []),
				...(!customDV7Access ? [{ id: 'backup_warning', title: 'Dangerous Backing-Up Alerts' }] : []),
				...(!customDV7Access ? [{ id: 'blind_spot_warning_standard', title: 'Standard Blind Spot Detection Warning' }] : []),
				...(!customDV7Access ? [{ id: 'blind_spot_warning_urban', title: 'Urban Blind Spot Detection Warning' }] : []),
				...(!customDV7Access ? [{ id: 'low_speeding', title: 'Blind Spot Detection Warning Low' }] : []),
				...(!customDV7Access ? [{ id: 'moderate_speeding', title: 'Blind Spot Detection Warning Moderate' }] : []),
				...(!customDV7Access ? [{ id: 'high_speeding', title: 'Blind Spot Detection Warning High' }] : []),
				...(!customDV7Access ? [{ id: 'severe_speeding', title: 'Blind Spot Detection Warning Severe' }] : []),
			] : [])
	],
	dmscheckboxes: [
		{ id: 'Drowsiness', title: 'Drowsiness/Head Down' },
		{ id: 'Phoneuse', title: 'Phone Use/Hand to Head' },
		{ id: 'Yawning', title: 'Yawning' },
		{ id: 'Distraction', title: 'Distraction' },
		{ id: 'Seatbelt', title: 'Seatbelt' },
		{ id: 'Smoking', title: 'Smoking' },
		{ id: 'camerablock', title: 'Potential Ch2 Obstruction' },
	],
	adascheckboxes: [
		{ id: 'headwaywarning', title: 'Headway Warning' },
		{ id: 'forwardcollisionwarning', title: 'Forward Collision' },
		...(!customDV7Access ? [{ id: 'pedestrianwarning', title: 'Pedestrian Warning' }] : []),
		{ id: 'lanedeparture', title: 'Lane Departure' },
		{ id: 'followingdistancewarning', title: 'Tailgating' },
		...(DV7access ?
			[
				...(!customDV7Access ? [{ id: 'front_vehicle_start', title: 'Front Vehicle Start Alert' }] : []),
				{ id: 'trafficlightviolation_saw', title: 'Signal Approach' },
				{ id: 'trafficlightviolation_svw', title: 'Signal Violation' },
				{ id: 'stopsignviolation_rsw', title: 'Rolling Stop' },
				{ id: 'stopsignviolation_bsw', title: 'Bypass Stop' },
			] : [])
	],
	eventcheckboxestitle: [
		{ id: 'fatalgsensor', title: 'High G-Force Event' },
		{ id: 'highspeed', title: 'Max Speed Event' },
		{ id: 'inputsensor5,inputsensor9', title: 'Driver Event' },
		{ id: 'inputsensor', title: 'Input Sensor Event' },
		...(!customDV7Access ? [{ id: 'pedestrianwarning', title: 'Pedestrian Warning' }] : []),
		{ id: 'headwaywarning', title: 'Headway Warning' },
		{ id: 'forwardcollisionwarning', title: 'Forward Collision' },
		{ id: 'lanedeparture', title: 'Lane Departure' },
		{ id: 'followingdistancewarning', title: 'Tailgating' },
		{ id: 'drowsiness', title: 'Drowsiness/Head Down' },
		{ id: 'distraction', title: 'Distraction' },
		{ id: 'phone_use', title: 'Phone Use/Hand to Head' },
		{ id: 'yawning', title: 'Yawning' },
		{ id: 'seatbelt', title: 'Seatbelt' },
		{ id: 'smoking', title: 'Smoking' },
	],
});

export default constants;
